import _Object$keys from 'babel-runtime/core-js/object/keys';
import _extends from 'babel-runtime/helpers/extends';
export var UPLOAD_AUDIO_SUBMISSION = 'UPLOAD_AUDIO_SUBMISSION';
export var UPLOAD_TEXT_SUBMISSION = 'UPLOAD_TEXT_SUBMISSION';
var SET_SUBMISSION_UPLOADED = 'SET_SUBMISSION_UPLOADED';
export var START_POLLING_SUBMISSIONS = 'START_POLLING_SUBMISSIONS';
export var STOP_POLLING_SUBMISSIONS = 'STOP_POLLING_SUBMISSIONS';
export var LOAD_MESSAGE_INFO = 'LOAD_MESSAGE_INFO';
export var SET_MESSAGE_VIEWED = 'SET_MESSAGE_VIEWED';

var SET_SUBMISSIONS = 'SET_SUBMISSIONS';
var CLEAR_SUBMISSIONS = 'CLEAR_SUBMISSIONS';
var ADD_MESSAGE_INFO = 'ADD_MESSAGE_INFO';

var initialSubmissionsState = {
  submissions: null,
  messageInfos: {},
  uploadComplete: false
};

export var submissionsReducer = function submissionsReducer() {
  var _extends2;

  var submissionsState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSubmissionsState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action && action.type) {
    // here is for actions that only want saga side-effects
    case STOP_POLLING_SUBMISSIONS:
    case START_POLLING_SUBMISSIONS:
    case LOAD_MESSAGE_INFO:
      return submissionsState;

    case SET_SUBMISSIONS:
      return _extends({}, submissionsState, {
        submissions: action.payload.submissions
      });

    case CLEAR_SUBMISSIONS:
      return initialSubmissionsState;

    case ADD_MESSAGE_INFO:
      return _extends({}, submissionsState, {
        messageInfos: _extends({}, submissionsState.messageInfos, (_extends2 = {}, _extends2[action.payload.messageInfo.messageId] = action.payload.messageInfo, _extends2))
      });

    case UPLOAD_AUDIO_SUBMISSION:
    case UPLOAD_TEXT_SUBMISSION:
      return _extends({}, submissionsState, {
        uploadComplete: false
      });
    case SET_SUBMISSION_UPLOADED:
      return _extends({}, submissionsState, {
        uploadComplete: action.payload.uploaded
      });

    default:
      return submissionsState;
  }
};

export var submissionsActions = {
  startPollingSubmissions: function startPollingSubmissions() {
    return { type: START_POLLING_SUBMISSIONS, payload: {} };
  },
  stopPollingSubmissions: function stopPollingSubmissions() {
    return { type: STOP_POLLING_SUBMISSIONS, payload: {} };
  },
  setSubmissions: function setSubmissions(submissions) {
    return { type: SET_SUBMISSIONS, payload: { submissions: submissions } };
  },
  clearSubmissions: function clearSubmissions() {
    return { type: CLEAR_SUBMISSIONS, payload: {} };
  },
  loadMessageInfo: function loadMessageInfo(messageId) {
    return { type: LOAD_MESSAGE_INFO, payload: { messageId: messageId } };
  },
  addMessageInfo: function addMessageInfo(messageInfo) {
    return {
      type: ADD_MESSAGE_INFO,
      payload: { messageInfo: messageInfo }
    };
  },

  setMessageViewedByLearner: function setMessageViewedByLearner(submissionId) {
    return {
      type: SET_MESSAGE_VIEWED,
      payload: { submissionId: submissionId }
    };
  },

  uploadAudioSubmission: function uploadAudioSubmission(submissionBlob, stepStatus, lessonTitle, submitStepFunc) {
    return {
      type: UPLOAD_AUDIO_SUBMISSION,
      payload: {
        submissionBlob: submissionBlob,
        stepStatus: stepStatus,
        lessonTitle: lessonTitle,
        submitStepFunc: submitStepFunc
      }
    };
  },

  uploadTextSubmission: function uploadTextSubmission(submissionText, stepStatus, lessonTitle, submitStepFunc, progressStepType) {
    return {
      type: UPLOAD_TEXT_SUBMISSION,
      payload: {
        submissionText: submissionText,
        stepStatus: stepStatus,
        lessonTitle: lessonTitle,
        submitStepFunc: submitStepFunc,
        progressStepType: progressStepType
      }
    };
  },

  setSubmissionUploaded: function setSubmissionUploaded(uploaded) {
    return {
      type: SET_SUBMISSION_UPLOADED,
      payload: { uploaded: uploaded }
    };
  }
};

export var submissionsSelectors = {
  getSubmissions: function getSubmissions(state) {
    return state.submissions.submissions;
  },
  getGradedSubmissions: function getGradedSubmissions(state) {
    return state.submissions.submissions && state.submissions.submissions.filter(function (submission) {
      return !!submission.gradedOn;
    });
  },
  getSubmission: function getSubmission(state, submissionId) {
    if (state.submissions.submissions) {
      return state.submissions.submissions.find(function (submission) {
        return submission.id === submissionId;
      });
    }
    return null;
  },
  getMessageInfo: function getMessageInfo(state, submissionId) {
    return state.submissions.messageInfos[submissionId];
  },
  getMessageInfoCount: function getMessageInfoCount(state) {
    return _Object$keys(state.submissions.messageInfos).length;
  },
  getUnviewedMessagesCount: function getUnviewedMessagesCount(state) {
    var messages = submissionsSelectors.getGradedSubmissions(state) || [];
    return messages.filter(function (m) {
      return !m.viewedByLearner;
    }).length;
  },
  submissionIsUploaded: function submissionIsUploaded(state) {
    return state.submissions.uploadComplete;
  }
};